import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from 'react'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import pick from 'lodash/pick'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import pickBy from 'lodash/pickBy'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import keys from 'lodash/keys'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isUndefined from 'lodash/isUndefined';
import { propTypes } from './api';
import TypeImpl from './TypeImpl';
import TypographyContext, { TypographyContextProvider } from '../../contexts/TypographyContext';

var Type = function Type(props) {
  var typographyContext = useContext(TypographyContext);
  return /*#__PURE__*/React.createElement(TypographyContextProvider // provide all needed props as context for child <Type /> nodes
  // seed the context for nested type by merging any matching defined props
  , _extends({}, pick(props, keys(typographyContext)), {
    // nested type is always `inline`
    inline: true
  }), /*#__PURE__*/React.createElement(TypeImpl // supply any undefined props from TypographyContext
  // gotham and chronicle are mutually exclusive. Values in props must override values in context.
  // Without unsetting the other font type, a nested <Type/> will receive both props, which
  // is undefined behavior and has the effect of rendering chronicle. This also must be done in TypographyContext
  // See https://github.com/NerdWallet/structured-content/pull/298
  , _extends({}, pickBy(typographyContext, function (val, key) {
    if (key === 'gotham' && val && props.chronicle) return false;
    if (key === 'chronicle' && val && props.gotham) return false;
    return isUndefined(props[key]);
  }), props)));
};

Type.propTypes = propTypes; // defaultProps are provided from `TypographyContext`

Type.defaultProps = {};
export default Type;